import { IRoute } from '../interfaces/routing';
import loadable from '@loadable/component';

const DashboardPage = loadable(() => import ('../pages/dashboards/dashboard/Dashboard'));
const ConsultantPage = loadable(() => import ('../pages/dashboards/AdminDashboard/consultant/Consultant'));
const ConsultantSingleProfile = loadable(() => import ('../pages/dashboards/AdminDashboard/consultant/ConsultantSingleProfile'));
const AddBlogPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Blogs/AddBlogPage'));
const ViewBlogPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Blogs/ViewBlogPage'));
const AddQuotePage = loadable(() => import ('../pages/dashboards/AdminDashboard/Quotes/AddQuotePage'));
const ViewQuotePage = loadable(() => import ('../pages/dashboards/AdminDashboard/Quotes/ViewQuotePage'));
const EditQuotePage = loadable(() => import ('../pages/dashboards/AdminDashboard/Quotes/EditQuotePage'));
const ViewQuoteTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Quotes/ViewQuoteTrashPage'));
const EditBlogPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Blogs/EditBlogPage'));
const ViewBlogTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Blogs/ViewBlogTrashPage'));
const AddKeywordPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Keywords/AddKeywordsPage'));
const AddSpecializationPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Specialization/AddSpecializationPage'));
const AddNationalityPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Nationality/AddNationalityPage'));
const AddDisordersPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Disorders/AddDisordersPage'));
const AddObjectivesPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Objectives/AddObjectivesPage'));
const AddLanguagesPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Languages/AddLanguagesPage'));
const ViewKeywordsPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Keywords/ViewKeywordsPage'));
const EditKeywordsPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Keywords/EditKeywordsPage'));
const ViewKeywordsTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Keywords/ViewKeywordsTrashPage'));
const EditLanguagesPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Languages/EditLanguagesPage'));
const ViewLanguagesPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Languages/ViewLanguagesPage'));
const ViewLanguagesTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Languages/ViewLanguagesTrashPage'));
const EditNationalityPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Nationality/EditNationalityPage'));
const ViewNationalityPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Nationality/ViewNationalityPage'));
const ViewNationalityTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Nationality/ViewNationalityTrashPage'));
const EditObjectivesPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Objectives/EditObjectivesPage'));
const ViewObjectivesPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Objectives/ViewObjectivesPage'));
const ViewObjectivesTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Objectives/ViewObjectivesTrashPage'));
const EditSpecializationPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Specialization/EditSpecializationPage'));
const ViewSpecializationPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Specialization/ViewSpecializationPage'));
const ViewSpecializationTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Specialization/ViewSpecializationTrashPage'));
const ViewComplaintPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Complaint/ViewComplaintPage'));
// const ViewComplaintTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Complaint/ViewComplaintTrashPage')); // undefined page
const AddComplaintTypePage = loadable(() => import ('../pages/dashboards/AdminDashboard/ComplaintType/AddComplaintTypePage'));
const ViewComplaintTypePage = loadable(() => import ('../pages/dashboards/AdminDashboard/ComplaintType/ViewComplaintTypePage'));
const ViewComplaintTypeTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/ComplaintType/ViewComplaintTypeTrashPage'));
const EditComplaintTypePage = loadable(() => import ('../pages/dashboards/AdminDashboard/ComplaintType/EditComplaintTypePage'));
const ViewDisorderPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Disorders/ViewDisorderPage'));
const AllBookingPage = loadable(() => import ('../pages/dashboards/AdminDashboard/AllBooking/AllBookingPage'));
const ViewComplaintClientPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Complaint/ComplaintClientPage'));
const EditComplaintPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Complaint/EditComplaintPage'));
const ChangePasswordPage = loadable(() => import ('../pages/dashboards/AdminDashboard/ChangePassword/ChangePasswordPage'));
const EditDisorderPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Disorders/EditDisorderPage'));
const ViewDisorderTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Disorders/ViewDisorderTrashPage'));
const AddDigitalProduct = loadable(() => import ('../pages/dashboards/AdminDashboard/DigitalProduct/AddDigitalProduct'));
const ViewDigitalProductPage = loadable(() => import ('../pages/dashboards/AdminDashboard/DigitalProduct/ViewDigitalProductPage'));
const ViewDigitalProductTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/DigitalProduct/ViewDigitalProductTrashPage'));
const EditDigitalProductPage = loadable(() => import ('../pages/dashboards/AdminDashboard/DigitalProduct/EditDigitalProductPage'));
const AddPrivacyPolicyPage = loadable(() => import ('../pages/dashboards/AdminDashboard/PrivacyPolicy/AddPrivacyPoilcy'));
const ViewPrivacyPolicyPage = loadable(() => import ('../pages/dashboards/AdminDashboard/PrivacyPolicy/ViewPrivacyPolicyPage'));
const ViewTrashPrivacyPage = loadable(() => import ('../pages/dashboards/AdminDashboard/PrivacyPolicy/ViewTrashPrivacyPage'));
const AddTermsConditionPage = loadable(() => import ('../pages/dashboards/AdminDashboard/TermsCondition/AddTermsConditionPage'));
const ViewTermsConditionPage = loadable(() => import ('../pages/dashboards/AdminDashboard/TermsCondition/ViewTermsConditionPage'));
const ClientPage = loadable(() => import ('../pages/dashboards/AdminDashboard/ClientList/Client'));
const ClientSingleProfile = loadable(() => import ('../pages/dashboards/AdminDashboard/ClientList/ClientSingleProfile'));
const WebSettingPage = loadable(() => import ('../pages/dashboards/AdminDashboard/webSetting/WebSettingPage'));
const ViewUserWaitingList = loadable(() => import ('../pages/dashboards/AdminDashboard/UserWaitingList/ViewUserWaitingList'));
const ContactUsList = loadable(() => import ('../pages/dashboards/AdminDashboard/UserWaitingList/ContactUsList'));
const AddCountryPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Country/AddCountryPage'));
const EditCountryPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Country/EditCountryPage'));
const ViewCountryPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Country/ViewCountryPage'));
const ViewCountryTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/Country/ViewCountryTrashPage'));
const AddCityPage = loadable(() => import ('../pages/dashboards/AdminDashboard/City/AddCityPage'));
const EditCityPage = loadable(() => import ('../pages/dashboards/AdminDashboard/City/EditCityPage'));
const ViewCityPage = loadable(() => import ('../pages/dashboards/AdminDashboard/City/ViewCityPage'));
const ViewCityTrashPage = loadable(() => import ('../pages/dashboards/AdminDashboard/City/ViewCityTrashPage'));
const ViewUserStarterKitRequests = loadable(() => import ('../pages/dashboards/AdminDashboard/UserWaitingList/ViewUserStarterKitRequests'));
export const adminRoutes: IRoute[] = [
    {
        path: 'change-password',
        component: ChangePasswordPage
    },
    {
        path: 'consultant',
        component: ConsultantPage
    },
    {
        path: 'client',
        component: ClientPage
    },
    {
        path: 'websetting',
        component: WebSettingPage
    },
    {
        path: 'client/client-profile/:id',
        component: ClientSingleProfile
    },
    {
        path: 'dashboard',
        component: DashboardPage
    },
    // {
    // 	path: 'appointmnents',
    // 	component: AdminAppointmentPage
    // },
    // {
    // 	path: 'transactions',
    // 	component: TransactionsDetailsPage
    // },
    {
        path: 'add-blog',
        component: AddBlogPage
    },
    {
        path: 'edit-blog/:id',
        component: EditBlogPage
    },
    {
        path: 'view-blog',
        component: ViewBlogPage
    },
    {
        path: 'view-trash-blog',
        component: ViewBlogTrashPage
    },
    {
        path: 'add-quote',
        component: AddQuotePage
    },
    {
        path: 'edit-quote/:id/:author_name/:quote_title',
        component: EditQuotePage
    },
    {
        path: 'view-quote',
        component: ViewQuotePage
    },
    {
        path: 'view-trash-quote',
        component: ViewQuoteTrashPage
    },
    {
        path: 'consultant/consultant-profile/:id',
        component: ConsultantSingleProfile
    },

    {
        path: 'add-disorders',
        component: AddDisordersPage
    },
    {
        path: 'edit-disorders/:id/:name',
        component: EditDisorderPage
    },
    {
        path: 'view-trash-disorders',
        component: ViewDisorderTrashPage
    },
    {
        path: 'add-keyword',
        component: AddKeywordPage
    },
    {
        path: 'edit-keywords/:id/:name',
        component: EditKeywordsPage
    },
    {
        path: 'view-keywords',
        component: ViewKeywordsPage
    },
    {
        path: 'view-trash-keywords',
        component: ViewKeywordsTrashPage
    },
    {
        path: 'add-languages',
        component: AddLanguagesPage
    },
    {
        path: 'edit-languages/:id/:name',
        component: EditLanguagesPage
    },
    {
        path: 'view-languages',
        component: ViewLanguagesPage
    },
    {
        path: 'view-trash-languages',
        component: ViewLanguagesTrashPage
    },
    {
        path: 'add-nationality',
        component: AddNationalityPage
    },
    {
        path: 'edit-nationality/:id/:name',
        component: EditNationalityPage
    },
    {
        path: 'view-nationality',
        component: ViewNationalityPage
    },
    {
        path: 'view-trash-nationality',
        component: ViewNationalityTrashPage
    },

    {
        path: 'add-country',
        component: AddCountryPage
    },
    {
        path: 'edit-country/:id',
        component: EditCountryPage
    },
    {
        path: 'view-country',
        component: ViewCountryPage
    },
    {
        path: 'view-trash-country',
        component: ViewCountryTrashPage
    },

    {
        path: 'add-city',
        component: AddCityPage
    },
    {
        path: 'edit-city/:id',
        component: EditCityPage
    },
    {
        path: 'view-city',
        component: ViewCityPage
    },
    {
        path: 'view-trash-city',
        component: ViewCityTrashPage
    },

    {
        path: 'view-disorders',
        component: ViewDisorderPage
    },
    {
        path: 'add-objectives',
        component: AddObjectivesPage
    },
    {
        path: 'edit-objectives/:id/:name',
        component: EditObjectivesPage
    },
    {
        path: 'view-objectives',
        component: ViewObjectivesPage
    },
    {
        path: 'view-trash-objectives',
        component: ViewObjectivesTrashPage
    },
    {
        path: 'add-specialization',
        component: AddSpecializationPage
    },
    {
        path: 'edit-specialization/:id/:name',
        component: EditSpecializationPage
    },
    {
        path: 'view-specialization',
        component: ViewSpecializationPage
    },
    {
        path: 'view-trash-specialization',
        component: ViewSpecializationTrashPage
    },
    {
        path: 'view-complaint-consultant',
        component: ViewComplaintPage
    },
    {
        path: 'view-complaint-client',
        component: ViewComplaintClientPage
    },
    // {
    //     path: 'view-trash-complaint',
    //     component: ViewComplaintTrashPage
    // },
    {
        path: 'edit-complaint/:id',
        component: EditComplaintPage
    },
    {
        path: 'add-complaintType',
        component: AddComplaintTypePage
    },
    {
        path: 'edit-ComplaintType/:id/:name',
        component: EditComplaintTypePage
    },
    {
        path: 'view-ComplaintType',
        component: ViewComplaintTypePage
    },
    {
        path: 'view-trash-ComplaintType',
        component: ViewComplaintTypeTrashPage
    },
    {
        path: 'all-booking',
        component: AllBookingPage
    },
    {
        path: 'add-privacy-policy',
        component: AddPrivacyPolicyPage
    },
    {
        path: 'add-terms-condition',
        component: AddTermsConditionPage
    },
    {
        path: 'view-terms-condition',
        component: ViewTermsConditionPage
    },
    {
        path: 'view-privacy-policy',
        component: ViewPrivacyPolicyPage
    },
    {
        path: 'view-trash-privacy-policy',
        component: ViewTrashPrivacyPage
    },
    {
        path: 'add-digital-product',
        component: AddDigitalProduct
    },
    {
        path: 'edit-digital-product/:id',
        component: EditDigitalProductPage
    },
    {
        path: 'view-digital-product',
        component: ViewDigitalProductPage
    },
    {
        path: 'view-trash-digital-product',
        component: ViewDigitalProductTrashPage
    },
    {
        path: 'view-user-waiting-list',
        component: ViewUserWaitingList
    },
    {
        path: 'view-contact-us-list',
        component: ContactUsList
    },
    {
        path: 'view-user-starter-kit-requests',
        component: ViewUserStarterKitRequests
    }
];